import type { RadarAlertOpportunity, RadarCompanyTracker, RadarPursuit } from "./api";

export const RADAR_VIEWS = [
  "all",
  "opportunities",
  "tracking",
  "claimed",
  "outreach",
  "follow_ups",
  "archive",
] as const;

export type RadarView = (typeof RADAR_VIEWS)[number];

export function isArchivedOpportunity(opportunity: RadarAlertOpportunity): boolean {
  return ["passed", "not_relevant", "expired", "revoked"].includes(opportunity.state);
}

export function opportunityMatchesView(
  opportunity: RadarAlertOpportunity,
  view: RadarView
): boolean {
  const archived = isArchivedOpportunity(opportunity);
  if (view === "archive") return archived;
  if (opportunity.pursuit_id || opportunity.state === "claimed") return false;
  if (view === "all" || view === "opportunities") return !archived;
  if (view === "follow_ups") return opportunity.state === "snoozed";
  return false;
}

export function pursuitMatchesView(pursuit: RadarPursuit, view: RadarView): boolean {
  if (view === "all") return pursuit.status === "active";
  if (view === "claimed") return pursuit.status === "active" && pursuit.stage === "claimed";
  if (view === "outreach") {
    return (
      pursuit.status === "active" && ["outreach", "meeting", "proposal"].includes(pursuit.stage)
    );
  }
  if (view === "follow_ups") return pursuit.status === "active" && Boolean(pursuit.follow_up_at);
  if (view === "archive") return pursuit.status !== "active";
  return false;
}

export function trackerMatchesView(tracker: RadarCompanyTracker, view: RadarView): boolean {
  if (view === "archive") return tracker.status === "archived";
  return tracker.status === "active" && (view === "all" || view === "tracking");
}
